import React from 'react'
import { Grid, Text, IconProps, csx } from '@vtex/admin-ui'
import { Icon } from '@vtex/phosphor-icons'

export type DeliveryMethodLabelProps = {
  Icon?: Icon<IconProps>
} & typeof Text.defaultProps

export const DeliveryMethodLabel = ({
  children,
  Icon,
  ...props
}: DeliveryMethodLabelProps) => (
  <Grid templateColumns="auto 1fr" gap="1">
    <div className={csx({ display: 'flex', width: '1rem' })}>
      {Icon && (
        <Icon
          size="small"
          className={csx({
            color: '$gray50',
            transform: 'scale(0.8)',
          })}
        />
      )}
    </div>
    <Text
      variant="detail"
      className={csx({
        display: 'flex',
        alignItems: 'center',
        color: '$gray50',
      })}
      {...props}
    >
      {children}
    </Text>
  </Grid>
)
